export class Map3D {
  constructor(difference) {
    this.width = 1000
    this.height = 700
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.innerElement = "cxMap3D" // 这个参数是用于组件设置的交互选项卡用，必须要有
    this.init(difference)
  }
  init(difference) {
    this.chartOption = difference
  }
}
